// Mirrors PROFILE_FIELDS in travelerblog/ai_chat/trip_profile.py -- keep in sync.
// `flags` is a reserved key of the stored profile and is not an editable field.
export const PROFILE_FIELD_ORDER = ['travelers', 'pace', 'interests', 'avoid', 'budget', 'constraints'];

const FIELD_LABEL_KEYS = {
  travelers: 'aiChatProfileTravelers',
  pace: 'aiChatProfilePace',
  interests: 'aiChatProfileInterests',
  avoid: 'aiChatProfileAvoid',
  budget: 'aiChatProfileBudget',
  constraints: 'aiChatProfileConstraints',
};

export function profileFieldLabelKey(field) {
  return FIELD_LABEL_KEYS[field];
}

function fieldValue(profile, field) {
  const entry = profile && typeof profile === 'object' ? profile[field] : null;
  if (!entry || entry.value === undefined || entry.value === null) return '';
  return String(entry.value).trim();
}

// {field: {value, source}} -> {field: string}, only fields that have a value.
export function profileValues(profile) {
  const out = {};
  PROFILE_FIELD_ORDER.forEach((field) => {
    const value = fieldValue(profile, field);
    if (value) out[field] = value;
  });
  return out;
}

export function isManagerWritten(profile, field) {
  const entry = profile && typeof profile === 'object' ? profile[field] : null;
  return !!entry && entry.source === 'manager';
}

// One-liner for the strip; '' when nothing is known.
export function summaryLine(profile, t) {
  const values = profileValues(profile);
  // These read as something else without their label ("no hiking" is not an interest).
  const labelled = ['avoid', 'budget', 'constraints'];
  const parts = PROFILE_FIELD_ORDER.filter(f => values[f])
    .map(f => (labelled.includes(f) ? `${t(FIELD_LABEL_KEYS[f])}: ${values[f]}` : values[f]));
  if (!parts.length) return '';
  return `${t('aiChatProfileStripPrefix')} ${parts.join(' · ')}`;
}
